import { CLEAR_UPLOADED_FACIAL_MAPPING_IMAGE, CLEAR_WALKIN_COMPLIANCES_DATA, DELETE_BATCH_NUMBER_DATA, SAVE_BATCH_NUMBER_DATA, SAVE_BATCH_NUMBER_DATA_AFTER_TREATMENT_REMOVED, SAVE_BEFORE_AND_AFTER_DATA, SAVE_BEFORE_AND_AFTER_DATA_AFTER_TREATMENT_REMOVED, SAVE_FACIAL_MAPPING_DATA, SAVE_NOTES_DATA, SAVE_TREATMENT_DATA, SAVE_UPLOADED_FACIAL_MAPPING_IMAGE } from "../../constants/walk-in-consent/walk-in-consent-const";

const initialState = {
    FacialMappingData: {},
    NotesData: null,
    treatmentListData: [],
    BeforeAndAfterData: [],
    BatchNumberData: [],
    uploadedStaticPhotoFacialMapping:null
};

export default function walkInConsentReducer(state = initialState, action) {

    switch (action.type) {

        case SAVE_FACIAL_MAPPING_DATA:
            return {
                ...state,
                FacialMappingData: action.payload,
            };

        case SAVE_NOTES_DATA:
            return {
                ...state,
                NotesData: action.payload,
            };

        case SAVE_TREATMENT_DATA:
            return {
                ...state,
                treatmentListData: action.payload
            }

        case SAVE_BEFORE_AND_AFTER_DATA:
            console.log("actiondaaataa", action.payload)
            let index = state?.BeforeAndAfterData?.findIndex((val) => val.treatmentId == action?.payload?.treatmentId);
            let data = state.BeforeAndAfterData;
            if (index == -1) {
                data = [...data, action.payload]
            }
            else {
                data[index] = action.payload
            }

            return {
                ...state,
                BeforeAndAfterData: data
            }

        case SAVE_BATCH_NUMBER_DATA:

            let indexBatch = state?.BatchNumberData?.findIndex((val) => val.treatmentId == action?.payload?.treatmentId);
            let batchNumberdata = state.BatchNumberData;
            if (indexBatch == -1) {
                batchNumberdata = [...batchNumberdata, action.payload]
            }
            else {
                batchNumberdata[indexBatch] = action.payload
            }

            return {
                ...state,
                BatchNumberData: batchNumberdata
            }

        case DELETE_BATCH_NUMBER_DATA:

            let batchIndexDelete = state?.BatchNumberData?.findIndex((val) => val.treatmentId == action?.payload);
            let batchNumberAfterDeleteData = state.BatchNumberData;

            batchNumberAfterDeleteData.splice(batchIndexDelete, 1)
            return {
                ...state,
                BatchNumberData: batchNumberAfterDeleteData
            }

        case CLEAR_WALKIN_COMPLIANCES_DATA:
            return {
                FacialMappingData: {},
                NotesData: null,
                treatmentListData: [],
                BeforeAndAfterData: [],
                BatchNumberData: []
            }

        case SAVE_BEFORE_AND_AFTER_DATA_AFTER_TREATMENT_REMOVED:
                return {
                    ...state,
                    BeforeAndAfterData: action.payload,
                }
        
        case SAVE_BATCH_NUMBER_DATA_AFTER_TREATMENT_REMOVED:
                return {
                    ...state,
                    BatchNumberData: action.payload,
                }
    
        case SAVE_UPLOADED_FACIAL_MAPPING_IMAGE:
                return {
                        ...state,
                        uploadedStaticPhotoFacialMapping: action.payload,
                };
        
        case CLEAR_UPLOADED_FACIAL_MAPPING_IMAGE:
                return {
                        ...state,
                        uploadedStaticPhotoFacialMapping: null,
                };
            
        default:
            return state;
    }

}




